// extracted by mini-css-extract-plugin
export var bounce = "_os-1";
export var generatingText = "_os-6";
export var lightning = "_os-4";
export var popup = "_os-5";
export var progressBar = "_os-7";
export var progressFill = "_os-8";
export var progressShimmer = "_os-9";
export var progressText = "_os-a";
export var shimmer = "_os-3";
export var uploadIcon = "_os-0";
export var uploadingText = "_os-2";